import styled from 'styled-components'

export default styled.article`
  width: 800px;
  border-radius: 4px;
  background-color: ${ ({ theme }) => theme.colors.white };
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 50px;
  padding: 50px;

  .backButton {
    width: 20px;
    height: 20px;
    margin: 0 0 20px 0;
    display: block;
    cursor: pointer;
  }

  .spinner-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 40px;
  }

  section {
    flex: 1;
    overflow-y: auto;
    font-size: 18px;

    h3 {
      margin-bottom: 30px;
      font-size: 20px;
    }

    label.fieldLabel {
      display: block;
      font-size: 14px;
      margin-bottom: 8px;
      color: ${ ({ theme }) => theme.colors.grey };
    }

    .radiobuttons-container {
      display: flex;
      flex-direction: row;
      gap: 30px;
      margin-bottom: 25px;
    }

    .select {
      margin-bottom: 25px;
      font-size: 15px;
    }

    textarea {
      font-family: ${ ({ theme }) => theme.fontFamily };
      width: 100%;
      min-height: 140px;
      box-sizing: border-box;
      padding: 10px;
      font-size: 15px;
      border: 1px solid ${ ({ theme }) => theme.colors.greyMedium };
      border-radius: 5px;
      resize: vertical;
      outline: none;

      &.invalid {
        border-color: ${ ({ theme }) => theme.colors.red };
      }
    }

    .anonymize-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
      margin-top: 15px;
      cursor: pointer;

      img {
        width: 25px;
        height: 25px;
      }

      span {
        font-size: 15px;
      }
    }
  }

  .link {
    cursor: pointer;
    color: ${ ({ theme }) => theme.colors.primary };
    text-decoration: underline;
    word-break: break-word;
  }

  .amb-links {
    display: flex;
    flex-direction: column;
    gap: 25px;

    .amb-link-title {
      font-weight: bold;
      margin-bottom: 5px;
    }
  }

  .sendButton {
    width: max-content;
    padding: 20px;
    margin-top: 20px;
    align-self: end;
  }

  @media screen and (max-width: 768px){
    width: 100%;
    margin: 0;
    overflow: auto;
    padding: 30px;
  }
`
